import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { Identifier } from 'react-admin';
import { User } from 'types/embedded/user';
import { getId } from 'utils/getId';

type UsersActivationResponse = { id: number; active: boolean }[];

export const activateUsers = async (userIds?: Identifier[]): Promise<UsersActivationResponse> => {
  return axios
    .put(`${Resources.Users}/activate/multiple`, { userIds })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const deactivateUsers = async (userIds?: Identifier[]): Promise<UsersActivationResponse> => {
  return axios
    .put(`${Resources.Users}/deactivate/multiple`, { userIds })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export type SaveUsersMerchantAccessParams = {
  userId: string;
  merchantIds: number[];
};

export const saveUsersMerchantAccess = async ({
  userId,
  merchantIds,
}: SaveUsersMerchantAccessParams): Promise<User> => {
  return axios
    .put(`${Resources.Users}/${getId(userId)}/merchant_access`, { merchantIds })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
